<template>
  <div class="timeline__container">
    <span
      v-if="resource.columns.title"
      v-editable.text="resource.columns.title"
      class="timeline__year"
    />
    <div class="timeline__text">
      <div
        v-if="resource.columns.text"
        v-editable.html="resource.columns.text"
      />
    </div>
  </div>
</template>

<script>
import editable from "@i22/frontend-cms-utils/mixins/editable";

export default {
  mixins: [editable],
};
</script>
